<template>
  <div v-if="showDeleteConfirmation" class="absolute inset-0 bg-gray-900/20 backdrop-blur-[2px] flex items-center justify-center z-10">
    <div class="bg-white rounded-xl shadow-xl p-6 max-w-md w-full mx-4">
      <div class="flex items-center gap-3 mb-4">
        <span class="material-symbols-outlined text-2xl text-red-500">warning</span>
        <h3 class="text-lg font-semibold text-gray-800">
          {{ t('settings.components.configuration.components.categoryModal.list.deleteModal.title') }} </h3>
      </div>

      <p class="text-gray-600 mb-2">
        {{ t('settings.components.configuration.components.categoryModal.list.deleteModal.message', { name: category?.name }) }} </p>
      <p class="text-sm text-gray-500 mb-6">
        {{ t('settings.components.configuration.components.categoryModal.list.deleteModal.warning') }} </p>

      <div class="flex items-center justify-end gap-3">
        <button @click="$emit('cancel')" class="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">
          {{ t('settings.components.configuration.components.categoryModal.list.deleteModal.cancel') }}
        </button>
        <button @click="$emit('confirm')" :disabled="isDeleting" class="px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 disabled:opacity-50 transition-all duration-300 flex items-center gap-2">
          <span class="material-symbols-outlined !text-base animate-spin" v-if="isDeleting">progress_activity</span> {{
            isDeleting
                ? t('settings.components.configuration.components.categoryModal.list.deleteModal.deleting')
                : t('settings.components.configuration.components.categoryModal.list.deleteModal.confirm')
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
  showDeleteConfirmation: {
    type: Boolean,
    default: false,
  },
  category: {
    type: Object,
    default: null,
  },
  isDeleting: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['confirm', 'cancel'])
</script>
